import { createRouter, createWebHistory } from "vue-router";
import { inject } from 'vue';
import { storeToRefs } from 'pinia'
import HomeIndex from "../components/sites/HomeIndex.vue";
import TestIndex from "../components/sites/TestIndex.vue";
import LoginIndex from "../components/sites/LoginIndex.vue";
import SocialloginIndex from "../components/objects/user/SocialloginIndex.vue";
import BestellenIndex from "../components/sites/objects/BestellenIndex.vue";
import DirectLogin from "../components/sites/objects/DirectLogin.vue";
import DirectWebinarEinladung from "../components/sites/objects/DirectWebinarEinladung.vue";
import DirectBestellung from "../components/sites/objects/DirectBestellung.vue";
import DirectGesamtausgabe from "../components/sites/objects/DirectGesamtausgabe.vue";
import DirectTabellen from "../components/sites/objects/DirectTabellen.vue";
import WebinareIndex from "../components/sites/objects/WebinareIndex.vue";
import WebinarIndex from "../components/sites/objects/WebinarIndex.vue";
import AccountIndex from "../components/sites/objects/AccountIndex.vue";
import InfoIndex from "../components/sites/objects/InfoIndex.vue";
import PraxiswissenIndex from "../components/sites/objects/PraxiswissenIndex.vue";
import LandingIndex from "../components/sites/objects/LandingIndex.vue";
import WunschzettelIndex from "../components/sites/objects/WunschzettelIndex.vue";
import RegisterIndex from "../components/sites/RegisterIndex.vue";
import RegisterBereitsRegistriertIndex from "../components/sites/RegisterBereitsRegistriertIndex.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeIndex,
  },
  {
    path: "/test",
    name: "test",
    component: TestIndex,
  },

  {
    path: "/start/:token/:redirect?/:id?",
    name: "start",
    component: DirectLogin,
  },
  {
    path: "/webinareinladung/:token/:webi_id",
    name: "webinareinladung",
    component: DirectWebinarEinladung,
  },
  {
    path: "/aufsteller/:token",
    name: "directbestellung",
    component: DirectBestellung,
  },
  {
    path: "/gesamtausgabe/:token",
    name: "gesamtausgabe",
    component: DirectGesamtausgabe,
  },
  {
    path: "/wunschzettel/:token?",
    name: "wunschzettel",
    component: WunschzettelIndex,
  },
  {
    path: "/waizmanntabellen/:token",
    name: "DirectTabellen",
    component: DirectTabellen,
  },
  {
    path: "/login",
    name: "login",
    component: LoginIndex,
  },
  {
    path: "/register/bereits-registriert",
    name: "registerBereitsRegistriert",
    component: RegisterBereitsRegistriertIndex,
  },
  {
    path: "/register/:id?",
    name: "register",
    component: RegisterIndex,
  },
  {
    path: "/social",
    name: "social",
    component: SocialloginIndex,
  },
  {
    path: "/praxiswebinare",
    name: "praxiswebinare",
    component: WebinareIndex,
  },
  {
    path: "/webinar/:id",
    name: "praxiswebinar",
    component: WebinarIndex,
  },
  {
    path: "/info/:type",
    name: "info",
    component: InfoIndex,
  },
  {
    path: "/praxiswissen/:type?",
    name: "praxiswissen",
    component: PraxiswissenIndex,
  },
  {
    path: "/praxisinfo/:type?/:token?",
    name: "landing",
    component: LandingIndex,
  },

  {
    path: "/waizmanntabellen_bestellen",
    name: "waizmanntabellen_bestellen",
    component: BestellenIndex,
        meta: {
        requiresAuth: true
    }
  },
  {
    path: "/account/:type?",
    name: "account",
    component: AccountIndex,
    meta: { requiresAuth: true },
  },
  // Fallback route for any /start paths that don't match above
  {
    path: "/start/:pathMatch(.*)*",
    name: "startFallback",
    component: DirectLogin,
  }


  // {
  //   // GESCHÜTZTE ROUTE: Benutzerprofil
  //   path: '/profile',
  //   name: 'Profile',
  //   component: Profile,
  //   meta: {
  //     requiresAuth: true
  //   }
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // Verwende inject, um den userStore zu erhalten
  const userStore = inject('userStore');
  const { userData } = storeToRefs(userStore);

  if (!userStore) {
    console.error('userStore is not available');
    next();
    return;
  }
  console.log('userData: ' + userData.value);
  // Beispiel: Überprüfe, ob der Benutzer eingeloggt ist
  if (to.meta.requiresAuth && !userData.value) {

    console.log('Benutzer ist nicht eingeloggt');
    next({ path: "/login" }); // Leite zur Login-Seite um
  } else {
    next(); // Erlaube die Navigation
  }
});
export default router;
